import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderConfirmed } from "@/interfaces/order-status.interfaces";
import orderStatusService from "@/services/order-status.service";
import { RequestsProps } from "@/types/requests.types";

export type ConfirmOrderProps = {
  formData: IOrderConfirmed;
} & RequestsProps;

export type UseConfirmOrderReturn = {
  create: (props: ConfirmOrderProps) => Promise<void>;
} & UseLoadingReturn;

const useConfirmOrder = (): UseConfirmOrderReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderConfirmed>({
    operation: (formData) => orderStatusService.confirm(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useConfirmOrder;
